// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer___a_oC","legacyBtn":"MutateMid_legacyBtn__zx0aj"};